import React, { FunctionComponent } from "react";

import Grid from "@material-ui/core/Grid";

import CardSolution from "shared/components/CardSolution/CardSolution";

const SolutionsList: FunctionComponent<{ solutions: any[] }> = ({
  solutions,
}) => {
  return (
    <div>
      {solutions && (
        <Grid container direction="row" spacing={3}>
          {solutions.map((solution: any) => (
            <Grid item xs={12} md={6} key={solution.id}>
              <CardSolution solution={solution} showFeedBackButton={false} />
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
};

export default SolutionsList;
